import React from 'react'
import { Outlet } from 'react-router-dom'
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Container,
} from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import Footer from './Footer'

const Layout = () => {
  const location = useLocation()

  const navItems = [
    { label: 'Simulation', path: '/' },
    { label: 'Explore', path: '/explore' },
    { label: 'About', path: '/about' },
    { label: 'Physics', path: '/physics' },
  ]

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="sticky" elevation={0}>
        <Toolbar sx={{ backdropFilter: 'blur(10px)' }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: 1,
              color: 'primary.main',
              fontWeight: 'bold',
              fontSize: '1.5rem',
              fontFamily: '"Orbitron", "Roboto", sans-serif',
              textShadow: '0 0 10px rgba(0, 255, 255, 0.5)',
            }}
          >
            🌌 Black Hole Explorer
          </Typography>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {navItems.map((item) => (
              <motion.div
                key={item.path}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Button
                  component={Link}
                  to={item.path}
                  color="inherit"
                  sx={{
                    backgroundColor: location.pathname === item.path 
                      ? 'rgba(0, 255, 255, 0.2)' 
                      : 'transparent',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 255, 255, 0.15)',
                      boxShadow: '0 0 20px rgba(0, 255, 255, 0.3)',
                      transform: 'translateY(-1px)',
                    },
                    borderRadius: '12px',
                    fontWeight: location.pathname === item.path ? 'bold' : 'normal',
                    fontFamily: '"Orbitron", "Roboto", sans-serif',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    border: location.pathname === item.path 
                      ? '1px solid rgba(0, 255, 255, 0.5)' 
                      : '1px solid transparent',
                  }}
                >
                  {item.label}
                </Button>
              </motion.div>
            ))}
          </Box>
        </Toolbar>
      </AppBar>

      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>

      <Footer />
    </Box>
  )
}

export default Layout
